import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Header({ navLinks, onOpenResume }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  const handleResumeClick = (event) => {
    event.preventDefault();
    closeMenu();
    if (typeof onOpenResume === 'function') onOpenResume();
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b backdrop-blur-xl transition-all duration-300 ${
        scrolled ? 'border-ink/15 bg-snow/85 shadow-sm' : 'border-ink/8 bg-snow/65'
      }`}
    >
      <div className={`section-wrap flex items-center justify-between transition-all duration-300 ${scrolled ? 'h-[64px]' : 'h-[74px]'}`}>
        <a
          href="#home"
          className="ui-nav-link inline-flex items-center gap-2.5 font-display text-base font-bold tracking-tight md:text-lg"
        >
          <img
            src="/favicon.svg"
            alt=""
            aria-hidden="true"
            width="32"
            height="32"
            className="h-7 w-7 rounded-md shadow-sm md:h-8 md:w-8"
          />
          <span>NITHIN CHOUDARY</span>
        </a>

        <nav className="hidden items-center gap-9 md:flex" aria-label="Primary Navigation">
          {navLinks.map((link) =>
            link.href.startsWith('/') ? (
              <Link
                key={link.href}
                to={link.href}
                className="ui-nav-link text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/65 hover:text-ink"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                className="ui-nav-link text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/65 hover:text-ink"
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            type="button"
            onClick={handleResumeClick}
            className="ui-button-light hidden items-center gap-2 rounded-full border border-ink/25 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink md:inline-flex"
          >
            Résumé
            <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path strokeLinecap="round" d="M9 12h6M12 9l3 3-3 3M5 4h11l4 4v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
            </svg>
          </button>
          <a
            href="#contact"
            className="ui-button-dark hidden rounded-full border border-ink bg-coal px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-white md:inline-flex"
          >
            Let&apos;s Talk
          </a>
          <button
            type="button"
            className="ui-chip rounded-full border border-ink/20 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink md:hidden"
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            {isMenuOpen ? 'Close' : 'Menu'}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isMenuOpen ? (
          <motion.nav
            id="mobile-menu"
            key="mobile-nav"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-ink/10 bg-snow/95 md:hidden"
            aria-label="Mobile Navigation"
          >
            <div className="section-wrap flex flex-col gap-5 py-5">
              {navLinks.map((link) =>
                link.href.startsWith('/') ? (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={closeMenu}
                    className="ui-nav-link text-sm font-semibold uppercase tracking-[0.18em] text-ink/70"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={closeMenu}
                    className="ui-nav-link text-sm font-semibold uppercase tracking-[0.18em] text-ink/70"
                  >
                    {link.label}
                  </a>
                )
              )}
              <div className="flex flex-wrap items-center gap-3">
                <a
                  href="#contact"
                  onClick={closeMenu}
                  className="ui-button-dark inline-flex w-fit rounded-full border border-ink bg-coal px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-white"
                >
                  Let&apos;s Talk
                </a>
                <button
                  type="button"
                  onClick={handleResumeClick}
                  className="ui-button-light inline-flex w-fit rounded-full border border-ink/30 px-5 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-ink"
                >
                  Résumé
                </button>
              </div>
            </div>
          </motion.nav>
        ) : null}
      </AnimatePresence>
    </header>
  );
}

export default Header;
